import { graphql } from "react-relay";
import { LoginBtn } from "@components/login-btn";

export const chromeLoginFragments = {
  viewer: graphql`
    fragment ChromeLogin_viewer on Viewer {
      ...LoginBtn_viewer
      user {
        id
      }
    }
  `,
};
